export const AD_REPORTER_HEIGHT = 30
export const BORDER_RADIUS = 5
export const HOISTED_BODY_CLASS = 'mediavine-video-hoisted'
export const PLAYLIST_TARGET_PREFIX = 'mediavine-playlist'
export const INSERTED_BODY_CLASS = 'mediavine-wrapper-inserted'
export const SKIP_BTN_CLASS = 'mediavine-video__skip-ad-button'
export const STICKY_BODY_CLASS = 'mediavine-video__has-sticky'
export const STICKY_TITLE_HEIGHT = 36
export const TARGET_DIV_CLASS = 'mediavine-video__target-div'
